import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
const CHECKOUT_URL = 'https://volleyball-ready.impultienda.ar/checkout';
interface CTAButtonProps {
  text: string;
  price?: string;
  className?: string;
  hideTrustBadges?: boolean;
  href?: string;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  price,
  className = '',
  hideTrustBadges = false,
  href = CHECKOUT_URL
}) => {
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-177" data-mp="aj86vaudd93o">
      <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="relative overflow-hidden bg-vbred hover:bg-vbred-dark text-white font-display text-xl md:text-3xl py-4 px-6 md:px-10 uppercase tracking-wide w-full md:w-auto flex items-center justify-center gap-3 shadow-[0_10px_30px_rgba(230,57,70,0.4)] transition-all duration-300 rounded-sm text-center group" data-id="element-178" data-mp="fh9lnjkrim9c">
        {/* Subtle shine effect */}
        <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-179" data-mp="34l684kz7itf6" />
        <span className="relative z-10" data-id="element-180" data-mp="30lfjonx5kpdt">{text}</span>
        {price && <span className="relative z-10 text-vbgold ml-2" data-id="element-181" data-mp="2vjq6b1mgjzmk">{price}</span>}
      </motion.a>
      {!hideTrustBadges && <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-4 text-xs md:text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-182" data-mp="2qmzsym21fi4u">
          <span className="flex items-center gap-1.5" data-id="element-183" data-mp="2gwdit7d3bjtj">
            <Lock className="w-4 h-4 text-vbgold" data-id="element-184" data-mp="2gszdbq94quhv" /> Secure Payment
          </span>
          <span className="flex items-center gap-1.5" data-id="element-185" data-mp="2crnmjheis383">
            <Zap className="w-4 h-4 text-vbgold" data-id="element-186" data-mp="27uxad55u5rry" /> Instant Access
          </span>
          <span className="flex items-center gap-1.5" data-id="element-187" data-mp="22v12uvxxji7n">
            <ShieldCheck className="w-4 h-4 text-vbgold" data-id="element-188" data-mp="22wcf7k5fxyad" /> 7-Day Guarantee
          </span>
        </div>}
    </div>;
};
export const SectionHeading: React.FC<{
  children: React.ReactNode;
  className?: string;
  eyebrow?: string;
}> = ({
  children,
  className = '',
  eyebrow
}) => <div className="text-center mb-8 md:mb-12" data-id="element-189" data-mp="1jbbyunmh8ac9">
    {eyebrow && <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="inline-flex items-center gap-2 px-3 py-1 bg-vbgold/10 text-vbgold border border-vbgold/20 rounded-full text-xs md:text-sm font-bold tracking-wider uppercase mb-4" data-id="element-190" data-mp="1o8c7n6apnr72">
        {eyebrow}
      </motion.div>}
    <motion.h2 initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`font-display text-3xl md:text-5xl uppercase tracking-tight ${className}`} data-id="element-191" data-mp="275wwiddh6pro">
      {children}
    </motion.h2>
    <motion.div initial={{
    scaleX: 0
  }} whileInView={{
    scaleX: 1
  }} viewport={{
    once: true
  }} transition={{
    delay: 0.2,
    duration: 0.5
  }} className="w-16 md:w-24 h-1 bg-vbred mx-auto mt-6 rounded-full" data-id="element-192" data-mp="o6p5vszn0yqb" />
  </div>;